import axios from 'axios';

export const BulletinOpenPlacesApi = {
  getBulletin: filter =>
    axios.get(`/api/public/data/buliten_of_free_place_by_filter?publishDateAscSorting=false`, { params: filter }),
  createDirectionApi: data => axios.post('/api/public/passport/direction', data),
  signStringDirection: data =>
    axios.post('/api/info/signature/sign_string/direction', data)
};
